import React from "react";
import "./styles.scss";

function TimeSensitive() {
  return (
    <React.Fragment>
      <div className="embed-container">
        <iframe
          src={process.env.REACT_APP_QUOTES}
          frameborder="0"
          allowfullscreen
        ></iframe>
      </div>
    </React.Fragment>
  );
}

export default TimeSensitive;
